import { render, staticRenderFns } from "./TransactionsCodes.vue?vue&type=template&id=2c6fb9ee&scoped=true&"
import script from "./TransactionsCodes.vue?vue&type=script&lang=js&"
export * from "./TransactionsCodes.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsCodes.vue?vue&type=style&index=0&id=2c6fb9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6fb9ee",
  null
  
)

export default component.exports